import { createAuthClient } from 'better-auth/react'

/**
 * Browser-side auth client.
 *
 * Safe to import into components: it only ever talks to our own /api/auth
 * routes. No bot token, no secret and no membership logic lives here — the
 * browser can ask to sign in, it can never assert that it is allowed to.
 */
export const authClient = createAuthClient({
    // Same-origin in this app, but explicit so the session cookie is always
    // sent and stored. Omitting this is the usual cause of a login that
    // "works" and then has no session on the next request.
    /**
     * Sign-in goes through `authClient.signIn.social({ provider: 'telegram-oidc' })`,
     * which is core Better Auth. The legacy widget client plugin is gone along
     * with its server half.
     */
    fetchOptions: { credentials: 'include' }
})

export const { useSession, signOut } = authClient
